// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
    color: red !important;
    margin: 10px;
}

.imgpreview {
    height: 50px;
    width: 50px;
}

.nav-tabs.nav-style-border .nav-item .nav-link.active {
    opacity: 1;
    visibility: visible;
}

.saveButton {
    /* position: absolute; */
    right: 30px;
    top: 20px
}

.delectButton {
    /* position: absolute; */
    right: 100px;
    top: 20px ;
    color: var(--admin-color) !important;
    border-color: var(--admin-color) !important;
    cursor: pointer;
}

.delectBtn {
    color: var(--admin-color) !important;
    border-color: var(--admin-color) !important;
    cursor: pointer;
}
.zip {
    color: #56606e;
    font-size: 15px;
    display: inline-block;
    margin-bottom: 0.5rem;
}

.separate_store input {
    height: 14px !important;
}

.domain_wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: end;
}

.domain_wrapper span {
    margin-bottom: 18px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Store/AddStore/StoreCreateForm.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX;AACJ;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,oCAAoC;IACpC,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".error {\n    color: red !important;\n    margin: 10px;\n}\n\n.imgpreview {\n    height: 50px;\n    width: 50px;\n}\n\n.nav-tabs.nav-style-border .nav-item .nav-link.active {\n    opacity: 1;\n    visibility: visible;\n}\n\n.saveButton {\n    /* position: absolute; */\n    right: 30px;\n    top: 20px\n}\n\n.delectButton {\n    /* position: absolute; */\n    right: 100px;\n    top: 20px ;\n    color: var(--admin-color) !important;\n    border-color: var(--admin-color) !important;\n    cursor: pointer;\n}\n\n.delectBtn {\n    color: var(--admin-color) !important;\n    border-color: var(--admin-color) !important;\n    cursor: pointer;\n}\n.zip {\n    color: #56606e;\n    font-size: 15px;\n    display: inline-block;\n    margin-bottom: 0.5rem;\n}\n\n.separate_store input {\n    height: 14px !important;\n}\n\n.domain_wrapper {\n    display: flex;\n    justify-content: flex-start;\n    align-items: end;\n}\n\n.domain_wrapper span {\n    margin-bottom: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
